/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-splash.js
 *
 * ロード後に実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * timeline
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

var tl = gsap.timeline({
  defaults: { duration: 1, ease: "power4.out" },
});

/**
 * to
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * actionToSplash
 * 全ページ用スプラッシュアクション
 */
function actionToSplash() {

  var maskTl = gsap.timeline({
    defaults: { duration: 1, ease: "power4.out" },
  });

  let mask = document.getElementById("mask");
  let maskInner = document.getElementById("mask__inner");

  maskTl.to(mask, {
    opacity: 1,
  }).to(maskInner, {
    opacity: 1,
  }, "-=0.75");
}

/**
 * actionToSplash
 * 初回読み込み用スプラッシュアクション
 */
function actionToFirstSplash() {

  var homeTl = gsap.timeline({
    defaults: { duration: 1, ease: "power4.out" },
  });

  //var
  var Body = document.body;
  var Header = document.getElementById('header');
  var mvCircle = document.getElementById('mvCircle');
  var mvImageMoive = document.getElementById('mvImageMoive');
  var mvPageNavShaft = document.getElementById('mvPageNavShaft');
  var mvPageNavLabel = document.querySelectorAll("#mvPageNav .list-label");
  var mvScrollDown = document.getElementById('mvScrollDown');
  var mvLead = document.querySelectorAll("#mvLead");
  var mvLeadText = document.querySelectorAll("#mvLead p span:not(.shadow)");

  //set
  gsap.set([mvImageMoive, mvLead, mvScrollDown, Header, mvPageNavLabel], {
    opacity: 0,
  });
  gsap.set([mvPageNavShaft], {
    rotateZ: -360,
    scale: 0,
  });
  gsap.set([mvCircle], {
    rotateY: -360,
  });

  //to
  homeTl
    .to([mvCircle], {
      opacity: 1,
      rotateY: 0,
      duration: 8,
    })
    .to([mvPageNavShaft], {
      scale: 1,
      rotateZ: 0,
      duration: 8,
    }, "<")
    .to([mvImageMoive], {
      opacity: 1,
      duration: 4,
    }, "-=5")
    .to([mvLead], {
      opacity: 1,
      scale: 1,
    }, "-=2")
    .to([Header], {
      opacity: 1,
    }, "<")
    .to([mvLeadText, mvScrollDown], {
      yPercent: 0,
      opacity: 1,
      stagger: {
        from: "start",
        amount: 0.7
      },
    }, "<")
    .to(mvPageNavLabel, {
      opacity: 1,
      duration: 3,
      stagger: {
        from: "start",
        amount: 0.2
      },
    }, "<")
    .to(Body, {
      overflow: "auto",
    })
}

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 */
function actionToSplashHome() {

  var homeTl = gsap.timeline({
    defaults: { duration: 1, ease: "power4.out" },
  });

  //var
  var Body = document.body;
  var Header = document.getElementById('header');
  var mvCircle = document.getElementById('mvCircle');
  var mvImageMoive = document.getElementById('mvImageMoive');
  var mvPageNavShaft = document.getElementById('mvPageNavShaft');
  var mvPageNavLabel = document.querySelectorAll("#mvPageNav .list-label");
  var mvPageNavCircle = document.querySelectorAll("#mvPageNav .list-circle");
  var mvScrollDown = document.getElementById('mvScrollDown');
  var mvLead = document.querySelectorAll("#mvLead");
  var mvLeadText = document.querySelectorAll("#mvLead p span:not(.shadow)");

  //set
  gsap.set([mvCircle, mvImageMoive, mvLead, mvScrollDown, Header, mvPageNavCircle], {
    opacity: 0,
  });
  gsap.set([mvPageNavShaft], {
    scale: 1,
    opacity: 0,
  });

  //to
  homeTl
    .to([mvCircle, mvLead, mvImageMoive, mvScrollDown, Header, mvPageNavShaft, mvPageNavCircle], {
      opacity: 1,
    })
    .to([mvLeadText], {
      yPercent: 0,
      opacity: 1,
      stagger: {
        from: "start",
        amount: 0.7
      },
    }, "<")
    .to([mvPageNavLabel], {
      opacity: 1,
      duration: 3,
      stagger: {
        from: "start",
        amount: 0.2
      },
    }, "<")
    .to(Body, {
      overflow: "auto"
    }, "-=3")
}

/**
 * actionToSplashLower
 * 下層ページ用スプラッシュアクション
 */
function actionToSplashLower() {

  //var
  var Body = document.body;
  var Header = document.getElementById('header');
  var ttlMv = document.getElementById('ttlMv');
  var ttlShutter = document.querySelectorAll("#ttlMv .shutter__create");
  var ttlMvMovie = document.getElementById('ttlMvMovie');
  var ttlText = document.getElementById('ttlText');
  var ttlTextJp = document.getElementById('ttlTextJp');
  var ttlCircle = document.querySelectorAll(".ttl-circle");
  var ttlScrollDown = document.getElementById('ttlScrollDown');
  var ttlDecCircle = document.getElementById('ttlDecCircle');
  var ttlLogo = document.getElementById('ttlLogo');

  //set
  if (ttlMv) {
    gsap.set([ttlMv], {
      opacity: 0,
    });
  }
  if (ttlMvMovie) {
    gsap.set([ttlMvMovie], {
      opacity: 0,
    });
  }
  gsap.set([ttlText, ttlTextJp], {
    opacity: 0,
    xPercent: -30,
  });
  gsap.set([Header, ttlCircle, ttlScrollDown], {
    opacity: 0,
  });
  gsap.set([ttlDecCircle], {
    scaleY: 1,
  });
  if (ttlLogo) {
    gsap.set([ttlLogo], {
      opacity: 0,
    });
  }

  //to
  tl.to(ttlDecCircle, {
    scaleY: 0,
    duration: 1,
  })
    .to(Body, {
      overflow: "auto"
    }, "<")
    .to(Header, {
      opacity: 1,
    })
    .to(ttlMv, {
      opacity: 1,
    }, "<")
    .to(ttlMvMovie, {
      opacity: 1,
    }, "<")
    .to(ttlScrollDown, {
      opacity: 1,
    }, "<")
    .to(ttlLogo, {
      opacity: 1,
    }, "<")
    .to(ttlText, {
      opacity: 1,
      xPercent: 0,
    }, "<")
    .to(ttlTextJp, {
      opacity: 1,
      xPercent: 0,
      delay: 0.1,
    }, "<")
    .to(ttlShutter, {
      opacity: 0,
      duration: 3,
    }, "<")
    .to(ttlCircle, {
      opacity: 1,
    }, "-=2");
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { actionToSplash, actionToFirstSplash, actionToSplashHome, actionToSplashLower };
